function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}
function cartFooter() {
  return document.querySelector('.drawer__footer')?.offsetHeight || 0;
}
function announcementHeight() {
  if (document.body.contains(document.querySelector('.announcement-bar'))) {
    const announcementHeight =
      document.querySelector('.announcement-bar').offsetHeight;
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);
document.documentElement.style.setProperty(
  '--cart-footer-height',
  cartFooter() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);

window.addEventListener(
  'resize',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--cart-footer-height',
      cartFooter() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );
  }, 50)
);

const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  const headerPlaceholder = siteHeader.closest('.shopify-section') || siteHeader.parentElement;
  const originalMinHeight = headerPlaceholder.style.minHeight;

  function fixHeader() {
    const stickyOffset = siteHeader.getBoundingClientRect().height;
    const scroll = window.scrollY;

    if (scroll > stickyOffset) {
      headerPlaceholder.style.minHeight = stickyOffset + 'px';
      siteHeader.classList.add('scrolling', 'fixed');
    } else {
      siteHeader.classList.remove('scrolling', 'fixed');
      headerPlaceholder.style.minHeight = originalMinHeight;
    }

    document.documentElement.style.setProperty('--header-height', stickyOffset + 'px');
  }

  window.addEventListener(
    'touchmove',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'scroll',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'resize',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener('load', (event) => {
    fixHeader();
  });

  if ('ResizeObserver' in window) {
    new ResizeObserver(fixHeader).observe(siteHeader);
  }

  fixHeader();
}

/************ Smooth Scroll  ****************/

document
  .querySelectorAll(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])'
  )
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('scroll to ', e);
      const offset = headerHeight() * -2;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;
        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);

        if (target.length) {
          const element = document.getElementById(target.replace('#', ''));
          console.log('element', element);
          window.scrollTo({
            top: getOffsetTop(element) + offset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  });

function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}
 
